"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _JPlayer2 = _interopRequireDefault(require("./JPlayer"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var JPlayerMobilePlayer = exports["default"] = /*#__PURE__*/function (_JPlayer) {
  (0, _inherits2["default"])(JPlayerMobilePlayer, _JPlayer);
  function JPlayerMobilePlayer() {
    (0, _classCallCheck2["default"])(this, JPlayerMobilePlayer);
    return _callSuper(this, JPlayerMobilePlayer, arguments);
  }
  (0, _createClass2["default"])(JPlayerMobilePlayer, [{
    key: "destroy",
    value:
    /**
     * Overriding the JPlayer's destroy method to keep
     * the JPlayerMobilePlayer from destroying itself
     * since it is loaded as a singleton. (See JPlayerFactory.)
     */
    function destroy() {
      this.jPlayerLibrary.off();
      this.jPlayerLibrary.jPlayer('clearMedia');
    }
  }]);
  return JPlayerMobilePlayer;
}(_JPlayer2["default"]);
//# sourceMappingURL=JPlayerMobilePlayer.js.map